export const GMB_CLIENT_ID = process.env.REACT_APP_GMB_CLIENT_ID || '';
